import { Grid } from "@mui/material";
import theme from "Theme/AppTheme";
import AcxSelect from "components/UI/Select/BaseSelectComponents/AcxSelect";
import { observer } from "mobx-react";
import React from "react";
import type ChartCardStore from "../ChartCardStore";
import type { SkillGroupingSelectorConfig } from "../../_DataEndpointConfig/Types";

type SkillGroupingControlProps = {
    store: ChartCardStore;
    selector: SkillGroupingSelectorConfig;
    /** Adds a gap on the left when another selector sits before this one. */
    followsSelector: boolean;
};

const SkillGroupingControl = observer(
    ({ store, selector, followsSelector }: SkillGroupingControlProps) => {
        return (
            // The controls row is justified space-between, which would push this to the far right
            // when it follows the module selector. The auto right margin absorbs the free space so
            // it stays beside the selector instead; right-hand controls keep their own auto left margin.
            <Grid
                item
                xs={3}
                sx={{
                    marginRight: "auto",
                    paddingLeft: followsSelector ? theme.spacing(1) : 0,
                }}
            >
                <AcxSelect
                    fullWidth
                    defaultValue={selector.options.find(
                        (option) => option.value === store.selectedSkillGrouping,
                    )}
                    options={selector.options}
                    onChange={(option) => {
                        if (option) {
                            store.setSkillGrouping(option.value);
                        }
                    }}
                    id={`signals-chart-select-skill-grouping-${store.id}`}
                    labelField="label"
                    valueField="value"
                    alternateItemColor={theme.palette.gray.main}
                    isDisabled={store.isReadOnly}
                    disabledAppearance="readOnly"
                />
            </Grid>
        );
    },
);

export default SkillGroupingControl;
